import cx from 'classnames';
import React from 'react';
import { isSizeLarge, isSizeSmall } from '../utils';
import { sizeType } from '../propTypes';

var Loader = function Loader(_ref) {
  var bsSize = _ref.bsSize;
  return React.createElement("div", {
    className: cx('rbt-loader', {
      'rbt-loader-lg': isSizeLarge(bsSize),
      'rbt-loader-sm': isSizeSmall(bsSize)
    })
  });
};

Loader.propTypes = {
  bsSize: sizeType
};
export default Loader;